import React from 'react';
import { Overview } from 'components/common/SideBar/Overview/Overview';
import { ParticipantsDetails } from 'components/common/SideBar/Participants/ParticipantsDetails';
import { Filters } from 'components/common/SideBar/Filters/Filters';
import { SidebarViews } from 'utils/constants';
import { CategorySidebar } from 'components/threepp/assessment/Filters/CategorySidebar';

export const SidebarWrapper = props => {
  const {
    assessment,
    assessmentLanguages,
    assessmentHelpText,
    assessmentProgress,
    assessmentAnsweredQuestions,
    assessmentTotalQuestions,
    sidebarView,
    participantsData,
    currentUser,
    isAssessmentDisabled,
    isOwner,
    onDeleteUser,
    onUpdateUser,
    open,
    setTriggerGuidedTour,
    activeUsers,
    actions,
    selectedCategory,
    visibleCategory,
    currentCategory,
    hasComments
  } = props;

  switch (sidebarView) {
    case SidebarViews.SECTIONS:
      return (
        <CategorySidebar
          assessment={assessment}
          actions={actions}
          selectedCategory={selectedCategory}
          visibleCategory={visibleCategory}
          currentCategory={currentCategory}
        />
      );
    case SidebarViews.FILTERS:
      return <Filters assessment={assessment} hasComments={hasComments} />;
    case SidebarViews.PARTICIPANT_DETAILS:
      return (
        <ParticipantsDetails
          participantsData={participantsData}
          currentUser={currentUser}
          isAssessmentDisabled={isAssessmentDisabled}
          isOwner={isOwner}
          onDeleteUser={onDeleteUser}
          onUpdateUser={onUpdateUser}
          activeUsers={activeUsers}
        />
      );
    case SidebarViews.OVERVIEW:
    default:
      return (
        <Overview
          assessment={assessment}
          assessmentLanguages={assessmentLanguages}
          assessmentHelpText={assessmentHelpText}
          assessmentProgress={assessmentProgress}
          assessmentAnsweredQuestions={assessmentAnsweredQuestions}
          assessmentTotalQuestions={assessmentTotalQuestions}
          open={open}
          setTriggerGuidedTour={setTriggerGuidedTour}
        />
      );
  }
};
